/**
 * @file shared/billing/admins.ts
 * @description FUENTE ÚNICA DE VERDAD de los correos con rol administrador.
 * Antes vivía duplicado en src/core/constants/defaults.ts y functions/src/billing/credit-types.ts.
 * REGLA DURA: TypeScript puro — sin imports de firebase, DOM ni Node.
 */

export const ADMIN_EMAILS: string[] = ["bussinesgrow2021@gmail.com"];
